import { z } from 'zod';

export const EmailTemplateVariableSchema = z.object({
  key: z.string(),
  label: z.string(),
  required: z.boolean(),
  example: z.string(),
});

export const EmailTemplateSchema = z.object({
  templateName: z.string(),
  templateKey: z.string(),
  subject: z.string(),
  htmlContent: z.string(),
  variables: z.array(EmailTemplateVariableSchema),
  placeholderDefaults: z.record(z.string(), z.string()).optional(),
});

export const UpdateEmailTemplateRequestSchema = z.object({
  subject: z.string().trim().max(300).optional(),
  htmlContent: z.string().trim().min(1),
  variables: z.array(EmailTemplateVariableSchema).optional(),
  placeholderDefaults: z.record(z.string(), z.string()).optional(),
});

export const PreviewEmailTemplateRequestSchema = z.object({
  sendTo: z.string().email().optional(),
  overrides: z.record(z.string(), z.string()).optional(),
});

export const PreviewEmailTemplateResponseSchema = z.object({
  success: z.literal(true),
  data: z.object({
    subject: z.string(),
    htmlContent: z.string(),
    sentTo: z.string().optional(),
  }),
  meta: z.object({ requestId: z.string(), timestamp: z.string() }),
});

export const EmailTemplateResponseSchema = z.object({
  success: z.literal(true),
  data: EmailTemplateSchema,
  meta: z.object({ requestId: z.string(), timestamp: z.string() }),
});

export const EmailTemplateListResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(EmailTemplateSchema),
  meta: z.object({ requestId: z.string(), timestamp: z.string() }),
});

export type EmailTemplateVariable = z.infer<typeof EmailTemplateVariableSchema>;
export type EmailTemplate = z.infer<typeof EmailTemplateSchema>;
export type UpdateEmailTemplateRequest = z.infer<typeof UpdateEmailTemplateRequestSchema>;
export type PreviewEmailTemplateRequest = z.infer<typeof PreviewEmailTemplateRequestSchema>;
